module.exports = __webpack_public_path__ + "media/images/themes/dark/fighting-donkeys-dc93b56f620414338698462268859dd7.gif";